module.exports = __webpack_public_path__ + "static/Rosewater2-235a65c35d944d7b4bcff96302ac0351.webp";